<template>
  <nav class="collapse navbar-collapse justify-content-end">
    <ul class="nav navbar-nav">
      <!-- bookmark folder -->
      <bookmark-folder-dropdown v-if="$currentUser" />

      <!-- alerts -->
      <alerts-dropdown v-if="$currentUser" />

      <!-- notifications -->
      <notification-dropdown v-if="$currentUser" />

      <support-dropdown />

      <get-started-dropdown />

      <li class="nav-item d-none d-sm-block"
        v-if="$can('inviteToAL')"
      >
        <a :href="`mailto:?subject=I%20invite%20you%20to%20check%20out%20AcademicLabs%2C%20the%20scientific%20intelligence%20platform%20made%20for%20you&body=Dear%20colleague%2C%0A%0AI'm%20using%20AcademicLabs%2C%20a%20scientific%20intelligence%20platform%20that%20makes%20it%20easy%20to%20find%20the%20most%20relevant%20experts%2C%20research%20groups%2C%20biotech%20startups%2C%20pharma%20research%20and%20collaborations%2C%20ongoing%20and%20published%20research%2C%20new%20projects%2C%20patents%2C%20clinical%20trials%2C%20research%20trends%2C%20and%20much%20more.%20I%20think%20you'd%20find%20it%20really%20useful%20for%20your%20work.%0A%0ASign%20up%20here%20to%20try%20a%20search%20and%20discover%20what%20you%20can%20find%3A%20https%3A%2F%2Fapp.academiclabs.com%2Fsignup%0A%0ATo%20learn%20more%2C%20here%E2%80%99s%20an%20intro%20video%20on%20the%20website%3A%20https%3A%2F%2Fwww.academiclabs.com%2F%0Aor%20schedule%20a%2010%E2%80%99%20demo%20session%3A%20https%3A%2F%2Fwww.academiclabs.com%2Facademiclabs-get-started%0A%0ABest%20Regards%2C%0A%0A${$currentUser.full_name}`"
          class="nav-link-button"
          target="_blank" rel="noopener noreferrer"
          v-tooltip="`Invite your colleagues to AcademicLabs`"
          @click="trackInviteClicked"
        >
          <i class="fa fa-user-plus" />
          <span class="ml-2 d-none d-lg-inline-block t-500">Invite</span>
        </a>
      </li>

      <!-- render profile dropdown -->
      <profile-dropdown
        v-if="$currentUser"
        :researchGroups="researchGroups"
      />

      <!-- user is not logged in -->
      <li v-if="!$currentUser" class="nav-item">
        <span class="nav-link t-white">
          <router-link :to="{name: 'login'}" class="t-white mr-2">Log in</router-link><span class="mr-2">|</span><router-link :to="{name: 'signup'}" class="t-white">Sign up</router-link>
        </span>
      </li>
    </ul>
  </nav>
</template>

<script>
import AlertsDropdown from '@/components/shared/header/dropdown/alerts/Alerts'
import BookmarkFolderDropdown from '@/components/shared/header/dropdown/Bookmarks'
import NotificationDropdown from '@/components/shared/header/dropdown/Notification'
import ProfileDropdown from '@/components/shared/header/dropdown/Profile'
import SupportDropdown from '@/components/shared/header/dropdown/Support'
import GetStartedDropdown from '@/components/shared/header/dropdown/GetStarted'

import MPService from '@/services/mixpanel'

export default {
  name: 'navBar',
  components: {
    ProfileDropdown,
    NotificationDropdown,
    SupportDropdown,
    BookmarkFolderDropdown,
    AlertsDropdown,
    GetStartedDropdown
  },
  data () {
    return {
      researchGroups: []
    }
  },
  created () {
    if (this.$currentUser) {
      this.researchGroups = this.$currentUser.research_groups
    }

    this.$events.$on('navbar:research_group:update:research_groups', (researchGroups) => { this.researchGroups = researchGroups })
  },
  methods: {
    trackInviteClicked () {
      MPService.trackEvent('invite_to_academiclabs')
    }
  },
  destroyed () {
    this.$events.$off('navbar:research_group:update:research_groups')
  }
}
</script>
